import { render, staticRenderFns } from "./SelectInput.vue?vue&type=template&id=01064ef9&"
import script from "./SelectInput.vue?vue&type=script&setup=true&lang=ts&"
export * from "./SelectInput.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./SelectInput.vue?vue&type=style&index=0&id=01064ef9&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports